import styled from 'styled-components';
import { IEX_STATE_CODES } from '../../constants/configs/states';
import { BREAK_POINTS } from '../../constants/common/breakpoints';

export const StyledLayoutContainer = styled.div<{ $stateCode: string }>`
    width: fit-content;
    justify-self: center;
    min-height: 700px;

    ${props =>
        props.$stateCode === IEX_STATE_CODES.MN
            ? `
        background-color: ${props.theme.defaultWhite};
        h1{
            margin-left: 10px;
        }
        `
            : ''}
`;

export const StyledHeading = styled.h3<{ $stateCode: string }>`
    min-height: 40px;
    margin-bottom: 20px;

    ${({ $stateCode, theme }) =>
        $stateCode == IEX_STATE_CODES.MN
            ? `
                background: ${theme.sidebar_header_bg};
                border-radius: 8px 8px 0 0;
                padding: 10px;`
            : ''}
`;

export const StyledDiv = styled.div<{ $stateCode: string }>`
    width: 100%;

    ${({ theme, $stateCode }) =>
        $stateCode === IEX_STATE_CODES.MN
            ? ''
            : `
        height: fit-content;
        padding-bottom: 20px;
        border: 1px solid ${theme.gray8};
        padding: 24px 24px 32px 24px;
        background-color: ${theme.defaultWhite};
        border-radius: 8px;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
        `}
`;

export const StyledDropdown = styled.div<{ $stateCode: string }>`
    width: fit-content;
    .small-width {
        width: 250px;
        @media (max-width: ${BREAK_POINTS.sm}) {
            width: 100%;
        }
        ${({ $stateCode }) => ($stateCode == IEX_STATE_CODES.MN ? ' height: 28px;' : '')}
    }
`;

export const StyledModalContent = styled.div<{ $statusMessage: string }>`
    ${({ $statusMessage }) => ($statusMessage === 'success' ? 'color: green;' : 'color: red;')};
`;

export const StyledErrorMessage = styled.div`
    color: red;
`;

export const StyledLabel = styled.label`
    margin-bottom: 8px;
`;

export const FlexRow = styled.div<{ $isPadding?: boolean }>`
    display: flex;
    gap: 24px;

    ${({ $isPadding }) => ($isPadding ? 'padding-left: 24px;' : '')}

    @media (max-width: ${BREAK_POINTS.sm}) {
        flex-direction: column;
    }
`;

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const StyledFileInput = styled.input`
    border: none !important;
    padding-top: 10px;
    font-size: 14px;
`;

export const StyledFileTypeContainer = styled.div`
    display: flex;
    gap: 10px;
`;
